export default __webpack_public_path__ + "static/media/icon_help.323a1539.svg";